import getCookie from '../helpers/get-cookie';

const listenersMap = new Map();
let intervalId;

const cookieStoreChangeListener = Object.freeze({
  add(newListeners) {
    if (!newListeners) return;

    newListeners.forEach(({ name, ...listeners }) => {
      listenersMap.set(name, listeners);
      return listenersMap;
    });

    if (window.cookieStore) {
      window.cookieStore.addEventListener('change', this.handleCookieStoreChange);
    } else {
      intervalId = setInterval(() => {
        // eslint-disable-next-line no-restricted-syntax
        for (const [cookieName, listeners] of listenersMap.entries()) {
          const cookieValue = getCookie(cookieName);

          if (!cookieValue && listeners.onDelete) {
            listeners.onDelete();
          }

          if (listeners.onChange) {
            listeners.onChange(cookieValue);
          }
        }
      }, 10000);
    }
  },

  remove() {
    if (listenersMap.size) return;
    listenersMap.clear();

    if (window.cookieStore) {
      window.cookieStore.removeEventListener('change', this.handleCookieStoreChange);
    } else {
      clearInterval(intervalId);
    }
  },

  handleCookieStoreChange(event) {
    const deletedCookies = event?.deleted;

    if (deletedCookies) {
      // eslint-disable-next-line no-restricted-syntax
      for (const cookie of deletedCookies) {
        const listeners = listenersMap.get(cookie.name);
        if (listeners?.onDelete) {
          listeners.onDelete();
        }
      }
    }

    const changedCookies = event?.changed;

    if (changedCookies) {
      // eslint-disable-next-line no-restricted-syntax
      for (const cookie of changedCookies) {
        const listeners = listenersMap.get(cookie.name);
        if (listeners?.onChange) {
          listeners.onChange(cookie.value);
        }
      }
    }
  },
});

export default cookieStoreChangeListener;
